import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMe } from "../features/me/meActions";
import { useNavigate } from "react-router";
import LocalStorageService from "../common/services/LocalStorageService";
import { FORBIDDEN_EVENT } from "../common/api/request";

// Minimum gap between two permission resyncs triggered by 403s: a page that
// fires several requests at once must not fetch /me/ once per failure.
const FORBIDDEN_RESYNC_GAP_MS = 5000;


export default function useApp() {
  const me = useSelector((state)=>state?.me?.info)
  const dispatch = useDispatch()
  const user = useSelector((state)=>state?.auth?.user)
  const mode = useSelector((state)=>state?.theme?.mode) || "light"
  const navigate = useNavigate()
  const lastForbiddenSyncRef = useRef(0)
  useEffect(()=>{
    if(LocalStorageService.get("authorizationData")?.access){
      dispatch(getMe())
    }
  },[user])
  // [CANA-654] A 403 means the stored permissions may be stale (group changed
  // by a superuser). Refetch /me/ so Can.js and the sidebar catch up.
  useEffect(()=>{
    const onForbidden = () => {
      const now = Date.now()
      if (now - lastForbiddenSyncRef.current < FORBIDDEN_RESYNC_GAP_MS) return
      if (!LocalStorageService.get("authorizationData")?.access) return
      lastForbiddenSyncRef.current = now
      dispatch(getMe())
    }
    window.addEventListener(FORBIDDEN_EVENT, onForbidden)
    return () => window.removeEventListener(FORBIDDEN_EVENT, onForbidden)
  },[dispatch])
  // Reflect the theme mode onto the DOM so our own --app-* CSS variables
  // (defined in styles/_themes.scss) switch. antd's --ant-* vars switch on
  // their own via the ConfigProvider algorithm.
  useEffect(()=>{
    document.body.setAttribute("data-theme", mode)
    // Also on <html>: iOS Safari paints the pull-to-refresh overscroll area
    // with the <html> background, and CSS on <html> can't read <body>'s attr.
    document.documentElement.setAttribute("data-theme", mode)
  },[mode])
  // useEffect(()=>{
  //  navigate("/admin")
  // },[me])
  return {
    me
  };
}
